export enum DistributeRewardImportType {
  MANUAL_ENTER = "MANUAL_ENTER",
  IMPORT_CSV = "IMPORT_CSV"
}
export enum DistributeRewardRecipient {
  EMPLOYEE = "EMPLOYEE",
  MANAGER = "MANAGER",
  FRIENDSFAMILY = "FRIENDSFAMILY",
  NONE = "NONE"
}
